import { useAccountPermissions } from '@frameio/permissions';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { usePaginatedWorkspaces } from './usePaginatedWorkspaces';

/**
 * useCanCreateWorkspace checks whether a user can create a new workspace
 * on the current account. Setting ignoreCount to false tells the hook to ignore
 * the case where a user has a single workspace, which is useful when we want
 * to show a New Workspace affordance for enterprise users that have currently
 * have a single workspace.
 */
export const useCanCreateWorkspace = (ignoreCount = true) => {
  const accountId = useActiveAccountId();
  const canCreateWorkspace = useAccountPermissions({
    accountId,
    check: 'canCreateWorkspace',
  });
  const { hasSingleWorkspace, isLimitedToOneWorkspace } =
    usePaginatedWorkspaces();

  return (
    canCreateWorkspace &&
    !isLimitedToOneWorkspace &&
    (ignoreCount || hasSingleWorkspace)
  );
};
